export default "__VITE_ASSET__BuG0eRFT__"